export const createContactRequests = (client) => ({
    createContactRequest: async (payload) => {
        const { data } = await client.api.create("contact-requests", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map